import CreateDatamate from "./CreateDatamate";
import MCPProvider from "./MCPProvider";

const MCPIntegrations = ( { startingStep } : { startingStep: number}) => {
  return (
    <MCPProvider>
      <CreateDatamate startingStep={startingStep}/>
    </MCPProvider>
  );
};

export default MCPIntegrations;
